import { format, isValid } from 'date-fns';

const getReadableDateTimeString = (dateString: string) => {
  if (dateString == null) {
    return '';
  }

  const date = new Date(dateString);

  if (!isValid(date)) {
    return '';
  }

  return format(date, 'dd MMM yy, h:mm a');
};

export default getReadableDateTimeString;
